/**
 * The bounds of `platform_config.turn_deadline_seconds`, which the admin contract's
 * `turnDeadlineSeconds` validates and ConversationDO's turn code reads. Declared apart from the
 * admin contract, which imports them, so that code loads them without that contract's schemas
 * (gh #5083, decision 61; `scripts/check-backend-startup-graph.ts`). The contracts barrel
 * exports them. Keep this module free of imports.
 */

/**
 * How long a native agent turn may run before it ends through the fail-safe
 * (`platform_config.turn_deadline_seconds`, #5083), in seconds from the turn's start. Its seed
 * is the PlatformDO column's default (600).
 *
 * The FLOOR lets a turn finish one full tool round trip with every step at its own bound: a
 * provider call waiting out its 120 s streaming header timeout, a tool at its 60 s fetch
 * bound (`EXTERNAL_TOOL_FETCH_TIMEOUT_MS`; a sync consult converts to async at 45 s), and the
 * answering provider call's 120 s again — 300 s. A call turn fits under it too: the voice
 * stops waiting for an answer after its `delegation_timeout_seconds`, at most 120 s. The
 * backend also bounds a turn at the floor when it cannot read the row (`turnDeadlineMs`).
 *
 * The MAXIMUM leaves a minute of the runtime's own limit: a Durable Object alarm handler and a
 * queue consumer are ended after 15 minutes of wall time, and the deadline counts from the
 * turn's start, after that invocation's own work before the turn, with the fail-safe still to
 * run once it fires. A deadline at or past 15 minutes could never end the turns they run.
 */
export const TURN_DEADLINE_SECONDS_FLOOR = 300;
export const TURN_DEADLINE_SECONDS_MAX = 840;
